const retailSaleRoutes = [
    {
        path: '/retail_sale',
        name: 'retailSale',
        children: [
            {
                path: '',
                name: 'retailSaleList',
                component: () => import('@/modules/retail_sale/list/List.vue'),
                meta: {
                    resource: 'retail-sales',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'Retail Sales',
                    breadcrumbs: [{ title: 'Retail Sales', routeName: 'retailSaleList' }]
                }
            }
        ]
    }
]

export default retailSaleRoutes
